import { createSlice } from "@reduxjs/toolkit";

export const UserInformationSlice = createSlice({
  name: "userInformation",
  initialState: {
    value: {},
  },
  reducers: {
    updateInformation: (state, action) => {
      state.value = action.payload;
    },
    removeInformation: (state) => {
      state.value = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateInformation, removeInformation } = UserInformationSlice.actions;

export const selectUserInformation = (state) => state.userInformation.value;

export default UserInformationSlice.reducer;
